import styled from "styled-components";

export const RecordingButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 4px;
  margin-bottom: 4px;
  row-gap: 8px;
`;